<template>
  <Block>
    <div class="px-6 py-4">
      <span class="text-xs font-semibold uppercase tracking-wide text-gray-400">Tips</span>
      <p class="text-sm font-medium text-gray-900 mt-1">{{ quote }}</p>
    </div>
  </Block>
</template>

<script>
import { Block } from "@estaly/ui";

export default {
  components: {
    Block,
  },
  props: {
    quote: {
      type: String,
      default: "",
    },
  },
};
</script>
